<template>
  <div class="bh-users-filters">
    <v-text-field
      :value="value"
      class="bh-input-pill rounded-pill"
      color="accent"
      height="48px"
      append-icon="bhi-loupe"
      placeholder="Search for users"
      filled
      clearable
      hide-details
      @input="onInput('fullName', $event)"
      @click:clear="clearSearch"
      @click:append="runSearch"
      @keydown.enter="runSearch"
    ></v-text-field>
  </div>
</template>
<script>
import { debounce } from "@/helpers/debounce"
export default {
  name: "BHUsersFilters",
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    tmpValue: ''
  }),
  methods: {
    clearSearch() {
      this.tmpValue = ''
      this.$emit('search-on:clear')
    },
    runSearch() {
      if (this.tmpValue)
        this.$emit('search-run', this.tmpValue)
    },
    onInput (key, value) {
      this.tmpValue = value
      debounce(() => {
        this.$emit('search-on:input', { key, value })
      },1000, 'BHUsersFilters')
    }
  }
};
</script>
<style lang="scss">
.bh-users-filters {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.bh-input-pill {
  margin: 0 8px !important;
  width: 264px;
  height: 48px !important;

  .v-input__slot {
    align-items: center;
    height: 48px;
    min-height: 0 !important;

    &::before,
    &::after {
      content: "";
      display: none;
    }

    .v-input__append-inner {
      align-self: center;
      margin-top: 0 !important;
    }

    .v-icon {
      color: $bh-blue;
    }
  }
}
</style>
